import { Heart, Plus, Check } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useCrawl } from "@/context/CrawlContext";
import { errMsg } from "@/lib/api";

export function SaveButton({ venue, className = "" }) {
  const { user, toggleSaved } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const saved = !!user && user.saved?.includes(venue.id);
  const onClick = async () => {
    if (!user) {
      toast("Log in to save your favorite spots");
      nav(`/login?next=${encodeURIComponent(loc.pathname)}`);
      return;
    }
    try {
      const nowSaved = await toggleSaved(venue.id);
      toast.success(nowSaved ? "Saved to your spots" : "Removed from saved");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <button
      data-testid={`save-btn-${venue.id}`}
      aria-label={saved ? "Remove from saved" : "Save venue"}
      onClick={onClick}
      className={`flex h-10 w-10 items-center justify-center rounded-full border transition-colors ${saved ? "border-rose-500/60 bg-rose-500/15 text-rose-400" : "border-zinc-700 text-zinc-400 hover:text-rose-300"} ${className}`}
    >
      <Heart size={18} fill={saved ? "currentColor" : "none"} />
    </button>
  );
}

export function CrawlButton({ venue, full = false }) {
  const { has, toggle } = useCrawl();
  const inCrawl = has(venue.id);
  return (
    <button
      data-testid={`crawl-btn-${venue.id}`}
      onClick={() => toggle(venue)}
      className={`flex items-center gap-1.5 rounded-full border px-3 py-2 text-xs font-bold transition-colors ${inCrawl ? "border-[#fde68a] bg-[#fde68a]/15 text-[#fde68a]" : "border-zinc-700 text-zinc-300 hover:border-zinc-500"}`}
    >
      {inCrawl ? <Check size={14} /> : <Plus size={14} />}
      {inCrawl ? "In crawl" : full ? "Add to bar crawl" : "Crawl"}
    </button>
  );
}
